import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CMSProvider } from './context/CMSContext';
import { AnalyticsProvider } from './context/AnalyticsContext';
import { ScrollToTop } from './components/common/ScrollToTop';
import { WhatsAppFloat } from './components/common/WhatsAppFloat';
import { GoogleTracking } from './components/common/GoogleTracking';
import Home from './pages/Home';
import About from './pages/About';
import Properties from './pages/Properties';
import PropertyDetail from './pages/PropertyDetail';
import OwnerListing from './pages/OwnerListing';
import ContactPage from './pages/ContactPage';
import Privacy from './pages/Privacy';
import Staging from './pages/Staging';
import ManualPage from './pages/ManualPage';
import Admin from './pages/Admin';
import NotFound from './pages/NotFound';

function App() {
  return (
    <CMSProvider>
      <GoogleTracking />
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/properties" element={<Properties />} />
            <Route path="/properties/:id" element={<PropertyDetail />} />
            <Route path="/owner-listing" element={<OwnerListing />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/staging" element={<Staging />} />
            <Route path="/manual" element={<ManualPage />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <WhatsAppFloat />
        </AnalyticsProvider>
      </BrowserRouter>
    </CMSProvider>
  );
}

export default App;
